import { Routes } from '@angular/router';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { PrestadorRelatoriosContent } from '@/features/registro/prestadores/relatorios/prestador-relatorios-content';
import { CertificadoRegularidadePjComponent } from '@/features/registro/prestadores/relatorios/components/certificado-regularidade-pj/certificado-regularidade-pj';
import { ReportCertidaoAlteracaoContratualPjComponent } from '@/features/registro/prestadores/relatorios/components/certidao-alteracao-contratual-pj/certidao-alteracao-contratual-pj';
import { ReportCertidaoResponsavelTecnicoPjComponent } from '@/features/registro/prestadores/relatorios/components/certidao-responsavel-tecnico-pj/certidao-responsavel-tecnico-pj';
import { ReportDeclaracaoResponsabilidadeTecnicaPjComponent } from '@/features/registro/prestadores/relatorios/components/declaracao-responsabilidade-tecnica-pj/declaracao-responsabilidade-tecnica-pj';
import { ReportDeclaracaoRtPgrssPjComponent } from '@/features/registro/prestadores/relatorios/components/declaracao-rt-pgrss-pj/declaracao-rt-pgrss-pj';
import { ReportTermoCompromissoDirecaoPjComponent } from '@/features/registro/prestadores/relatorios/components/termo-compromisso-direcao-pj/termo-compromisso-direcao-pj';
import { ReportTermoCompromissoPublicidadePjComponent } from '@/features/registro/prestadores/relatorios/components/termo-compromisso-publicidade-pj/termo-compromisso-publicidade-pj';
import { ReportTermoDefinicaoPrazoPjComponent } from '@/features/registro/prestadores/relatorios/components/termo-definicao-prazo-pj/termo-definicao-prazo-pj';
import { ReportOficioDeferimentoPjComponent } from '@/features/registro/prestadores/relatorios/components/oficio-deferimento-pj/oficio-deferimento-pj';
import { ReportCertidaoDiretorClinicoPjComponent } from '@/features/registro/prestadores/relatorios/components/certidao-diretor-clinico-pj/certidao-diretor-clinico-pj';
import { ReportCertificadoInscricaoPjComponent } from '@/features/registro/prestadores/relatorios/components/certificado-inscricao-pj/certificado-inscricao-pj';
import { ReportCertidaoCancelamentoPjComponent } from '@/features/registro/prestadores/relatorios/components/certidao-cancelamento-pj/certidao-cancelamento-pj';
import { ReportDeclaracaoSubstituicaoDiretorTecnicoPjComponent } from '@/features/registro/prestadores/relatorios/components/declaracao-substituicao-diretor-tecnico-pj/declaracao-substituicao-diretor-tecnico-pj';
import { ReportCertidaoSuspensaoPjComponent } from '@/features/registro/prestadores/relatorios/components/certidao-suspensao-pj/certidao-suspensao-pj';
import { ReportOficioSubstituicaoDiretorTecnicoPjComponent } from '@/features/registro/prestadores/relatorios/components/oficio-substituicao-diretor-tecnico-pj/oficio-substituicao-diretor-tecnico-pj';
import { ReportCartPjComponent } from '@/features/registro/prestadores/relatorios/components/cart-pj/cart-pj';
import { ReportRequerimentoRenovacaoPjComponent } from '@/features/registro/prestadores/relatorios/components/requerimento-renovacao-pj/requerimento-renovacao-pj';
import { ReportRequerimentoRenovacaoRegularidadePjComponent } from '@/features/registro/prestadores/relatorios/components/requerimento-renovacao-regularidade-pj/requerimento-renovacao-regularidade-pj';
import { ReportReciboProtocoloPjComponent } from '@/features/registro/prestadores/relatorios/components/recibo-protocolo-pj/recibo-protocolo-pj';
import { ReportSolicitacaoDocumentosPjComponent } from '@/features/registro/prestadores/relatorios/components/solicitacao-documentos-pj/solicitacao-documentos-pj';
import { ReportDeclaracaoDadosEmpresaPjComponent } from '@/features/registro/prestadores/relatorios/components/declaracao-dados-empresa-pj/declaracao-dados-empresa-pj';
import { ReportFichaCadastralPjComponent } from '@/features/registro/prestadores/relatorios/components/ficha-cadastral-pj/ficha-cadastral-pj';
import { RelatorioSelecaoPj } from '@/features/registro/prestadores/relatorios/components/relatorio-selecao-pj/relatorio-selecao-pj';

/** Rotas de relatórios de Prestadores (filhas de `prestadores/relatorios`). */
export const prestadorRelatoriosRoutes: Routes = [
    {
        path: 'relatorios',
        component: PrestadorRelatoriosContent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Relatórios', permission: PERMISSOES.prestadores.relatorios.escopo },
        children: [
            {
                path: 'certificado-regularidade-pj',
                component: CertificadoRegularidadePjComponent,
                data: { breadcrumb: 'Certificado de Regularidade' }
            },
            {
                path: 'certidao-alteracao-contratual-pj',
                component: ReportCertidaoAlteracaoContratualPjComponent,
                data: { breadcrumb: 'Certidão de Alteração Contratual' }
            },
            {
                path: 'certidao-responsavel-tecnico-pj',
                component: ReportCertidaoResponsavelTecnicoPjComponent,
                data: { breadcrumb: 'Certidão de Responsável Técnico' }
            },
            {
                path: 'declaracao-responsabilidade-tecnica-pj',
                component: ReportDeclaracaoResponsabilidadeTecnicaPjComponent,
                data: { breadcrumb: 'Declaração de Responsabilidade Técnica' }
            },
            {
                path: 'declaracao-rt-pgrss-pj',
                component: ReportDeclaracaoRtPgrssPjComponent,
                data: { breadcrumb: 'Declaração de Responsabilidade Técnica - PGRSS' }
            },
            {
                path: 'oficio-deferimento-pj',
                component: ReportOficioDeferimentoPjComponent,
                data: { breadcrumb: 'Ofício de Deferimento' }
            },
            {
                path: 'termo-compromisso-direcao-pj',
                component: ReportTermoCompromissoDirecaoPjComponent,
                data: { breadcrumb: 'Termo de Compromisso de Direção' }
            },
            {
                path: 'termo-compromisso-publicidade-pj',
                component: ReportTermoCompromissoPublicidadePjComponent,
                data: { breadcrumb: 'Termo de Compromisso de Publicidade' }
            },
            {
                path: 'termo-definicao-prazo-pj',
                component: ReportTermoDefinicaoPrazoPjComponent,
                data: { breadcrumb: 'Termo de Definição de Prazo' }
            },
            {
                path: 'certidao-cancelamento-pj',
                component: ReportCertidaoCancelamentoPjComponent,
                data: { breadcrumb: 'Certidão de Cancelamento' }
            },
            {
                path: 'certidao-diretor-clinico-pj',
                component: ReportCertidaoDiretorClinicoPjComponent,
                data: { breadcrumb: 'Certidão de Diretor Clínico' }
            },
            {
                path: 'certificado-inscricao-pj',
                component: ReportCertificadoInscricaoPjComponent,
                data: { breadcrumb: 'Certificado de Inscrição' }
            },
            {
                path: 'declaracao-substituicao-diretor-tecnico-pj',
                component: ReportDeclaracaoSubstituicaoDiretorTecnicoPjComponent,
                data: { breadcrumb: 'Declaração de Substituição de Diretor Técnico' }
            },
            {
                path: 'cart-pj',
                component: ReportCartPjComponent,
                data: { breadcrumb: 'Certidão de Responsabilidade Técnica (CART)' }
            },
            {
                path: 'certidao-suspensao-pj',
                component: ReportCertidaoSuspensaoPjComponent,
                data: { breadcrumb: 'Certidão de Suspensão' }
            },
            {
                path: 'oficio-substituicao-diretor-tecnico-pj',
                component: ReportOficioSubstituicaoDiretorTecnicoPjComponent,
                data: { breadcrumb: 'Ofício de Substituição de Diretor Técnico' }
            },
            {
                path: 'requerimento-renovacao-pj',
                component: ReportRequerimentoRenovacaoPjComponent,
                data: { breadcrumb: 'Requerimento de Renovação' }
            },
            {
                path: 'requerimento-renovacao-regularidade-pj',
                component: ReportRequerimentoRenovacaoRegularidadePjComponent,
                data: { breadcrumb: 'Requerimento de Renovação de Regularidade' }
            },
            {
                path: 'declaracao-dados-empresa-pj',
                component: ReportDeclaracaoDadosEmpresaPjComponent,
                data: { breadcrumb: 'Declaração de Dados da Empresa' }
            },
            {
                path: 'ficha-cadastral-pj',
                component: ReportFichaCadastralPjComponent,
                data: { breadcrumb: 'Ficha Cadastral' }
            },
            {
                path: 'recibo-protocolo-pj',
                component: ReportReciboProtocoloPjComponent,
                data: { breadcrumb: 'Recibo de Protocolo' }
            },
            {
                path: 'solicitacao-documentos-pj',
                component: ReportSolicitacaoDocumentosPjComponent,
                data: { breadcrumb: 'Solicitação de Documentos' }
            },
            {
                path: 'relatorio-selecao-pj',
                component: RelatorioSelecaoPj,
                data: { breadcrumb: 'Relatório por Seleção' }
            }
        ]
    }
];
